import { injectGlobal } from '@emotion/css';

// Needs to at least >99999 because of some customers
export const zIndexModal = 999999;

// Define the updated global styles
injectGlobal(`
  .react-aria-ModalOverlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: var(--visual-viewport-height);
    background: rgba(0, 0, 0, 0.7); 
    display: flex;
    align-items: center;
    justify-content: center;
     
    z-index: ${zIndexModal};

    &[data-entering] {
      animation: modal-fade 300ms ease-out; 
    }

    &[data-exiting] {
      animation: modal-fade 200ms reverse ease-in;
    }
  }

  .react-aria-Modal {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    outline: none;
    max-width: calc(100% - 20px);
    max-height: calc(100% - 20px);
    &[data-entering] {
      animation: modal-zoom 400ms cubic-bezier(0.175, 0.885, 0.32, 1.275); 
    }
  }

  @keyframes modal-fade {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes modal-zoom {
    from {
      transform: scale(0.8);
    }
    to {
      transform: scale(1);
    }
  }
`);
